import { useMutation } from '@tanstack/react-query';
import api from '@api/http/api';

export function useEquipModMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { targetId: string; slot: number; id: string; }
  >({
    mutationFn: (values) => api.post('/mods/equip', values),
  });
}

export function useDissolveModsMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { amount: number; id: string, }
  >({
    mutationFn: (values) => api.post('/mods/dissolve', values),
  });
}

export function useUnequipModMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { targetId: string; id: string; }
  >({
    mutationFn: (values) => api.post('/mods/unequip', values),
  });
}

export function useUpgradeModMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { level: number; id: string, }
  >({
    mutationFn: (values) => api.post('/mods/upgrade', values),
  });
}

export function useEvolveChassisMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { id: string }
  >({
    mutationFn: (values) => api.post('/mods/evolve-chassis', values),
  });
}

export function useEvolveWeaponMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { id: string }
  >({
    mutationFn: (values) => api.post('/mods/evolve-weapon', values),
  });
}

export function useFuseModsMutation() {
  return useMutation<
    { success: true },
    { error: string },
    { id: string }
  >({
    mutationFn: (values) => api.post('/mods/fuse', values),
  });
}

export function useQuickDissolveModsMutation() {
  return useMutation<{ success: true }>({
    mutationFn: () => api.post('/mods/quick-dissolve'),
  });
}
